<template>
  <v-container

    id="crud"
    fluid
    tag="section"
    class="px-6 mx-0"
  >
    <div v-if="$store.state.carrito.data.length == 0">
      <div
        style="height: 320px"
        class="carritoMsg__div px-2 d-flex flex-column justify-center align-items-center"
      >
        <div style="position: relative; display: inline-block">
          <v-icon
            color="text-center"
            style="font-size: 5rem; top: 0; left: 45%; pointer-events: none"
            >mdi-cart-outline</v-icon
          >

          <v-btn
            class="text-center primary"
            dark
            elevation="0"
            fab
            icon
            x-small
            style="position: absolute; top: 0; left: 47%; pointer-events: none"
          >
            <span style="font-size: 14px; padding: 5px">0</span>
          </v-btn>
        </div>
        <br />
        <p
          style="line-height: 1; font-weight: 500"
          class="display-1 text-center"
        >
          Tu carrito está vacio
        </p>
        <small style="line-height: 1; color: #999" class="text-center">
          Actualmente no hay productos en su carrito.<br />Puede seguir
          comprando y agregar los productos deseados.  <br><br><br>
          <v-btn
                width="150"
                color="success"
                class="text-center capitalize-first custom-btn"
                @click="verProductos"
              >
                Ver productos
              </v-btn>
        </small>


      </div>
    </div>
    <div v-else>
      <v-row class="my-2 px-0 mx-0">
        <v-col cols="auto" md="12" class="px-0 mx-0">
          <v-alert
            outlined
            type="info"
            colored-border
            color="info"
            elevation="2"
            class="mb-0"
          >
            <p class="info--text py-0 my-0" style="font-weight: 400">
              Los métodos de pago varían según los productos en tu carrito.
              Selecciona una opción para cada categoría. Si eliges 'Cheque Banco
              Nación', se te solicitarán los datos al presionar 'Confirmar’
            </p>
          </v-alert>
        </v-col>

        <v-col
          cols="auto"
          md="12"
          class="px-0 py-0 mx-0"
          v-if="$store.state.carrito.total > 9999999"
        >
          <v-alert
            outlined
            type="info"
            colored-border
            color="info"
            elevation="2"
            class="my-0 mb-4"
          >
            <p class="info--text py-0 my-0" style="font-weight: 400">
              Para montos superiores a $9.999.999 el método de pago 'Boleta Banco Nación' no estará disponible.
            </p>
          </v-alert>
        </v-col>

        <v-col cols="auto" md="4" class="">
          <v-badge
            v-if="$store.state.carrito.cantItem > 0"
            color="primary"
            overlap
            bordered
          >
            <template v-slot:badge>
              <span>{{ $store.state.carrito.cantItem }}</span>
            </template>

            <v-icon class="icon-25">mdi-cart-outline</v-icon>
          </v-badge>
          <v-badge v-else overlap bordered>
            <template v-slot:badge>
              <span>0</span>
            </template>

            <v-icon style="color: #000; font-size: 30px"
              >mdi-cart-outline</v-icon
            >
          </v-badge>
          <span class="ml-3 text-h6" style="">Carrito</span>
        </v-col>
      </v-row>





      <Loading  v-if="isLoading" :isLoading="isLoading" :loadingMsg="loadingMsg" />

      <v-row class="my-0 px-0 mx-0" v-else>
        <v-col cols="auto" md="9" class="ma-0 pa-0 pr-2">
          <v-row v-if="this.$store.state.carrito.cliente.CardCode" class="elevation-3 mx-1 pt-1 pb-0 mt-0 mb-1 rounded-lg">
              <v-col class="col-md-12 py-0 mt-3   text-left"  >
                  <span style="font-weight: 600;">Nombre: </span>
                  <span>{{  this.$store.state.carrito.cliente.CardName}}</span>
              </v-col>
              <v-col class="col-md-6 py-0 mt-3   text-left">
                  <span style="font-weight: 600;">Documento: </span>
                  <span>{{  this.$store.state.carrito.cliente.FederalTaxID}}</span>
              </v-col>
          </v-row>
          <div
            v-for="(tipo, index) in carritoTiposElementos"
            :key="tipo.TipoElementosId"
            class="mb-4"
          >
            <v-card class="bg-secondary">
              <v-card-title style="border-bottom: 1px solid #ddd">
                <v-row class="py-0 px-0" style="height: 68px">
                  <v-col
                    cols="auto"
                    style="width: 5%"
                    class="px-0 mx-0 py-0 mt-3"
                  >
                    <v-btn
                      x-small
                      @click="toggleCard(index)"
                      class="btn-panel-mas-menos ml-1"
                    >
                      <v-icon style="font-size: 1.2rem">{{
                        cardStates[index] ? "mdi-minus" : "mdi-plus"
                      }}</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col
                    cols="auto"
                    style="width: 50%"
                    class="px-0 mx-0 font-weight-bold py-0 mt-3 text-left"
                    >{{ tipo.TipoElementosDesc }}</v-col
                  >
                  <v-col
                    cols="auto"
                    md="1"
                    class="px-0 mx-0 font-weight-bold py-0 mt-4"
                  >
                    <div
                      class="mdi-credit-card-2 ml-3"
                      style="height: 30px"
                    ></div>
                  </v-col>
                  <v-col
                    cols="auto"
                    md="4"
                    class="text-end px-0 mx-0 font-weight-bold"
                  >
                    <v-select
                      :items="metodosPagoFiltrados"
                      label="Método de pago"
                      dense
                      solo
                      chips
                      x-small
                      class="small-select"
                      v-model="tipo.MetodoPago"
                      item-text="desc"
                      item-value="code"
                      @change="changeMethodPayment(tipo)"
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          :input-value="data.selected"
                          color="primary"
                          dark
                          style="padding: 13px 15px !important"
                          small
                          close-icon
                        >
                          {{ data.item.desc }}
                        </v-chip>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
              </v-card-title>

              <!-- Contenido desplegable de cada tarjeta -->
              <v-card-text v-if="cardStates[index]" class="px-2">


                      <!--componente cheque-->

                      <form-cheque  v-if="tipo.MetodoPago=== 'BANKNACION_CHEQUE'"
                      :tipo="tipo"
                      :carritoTiposElementos="carritoTiposElementos"
                      :ref="`chequeForm_${tipo.TipoElementosId}`"
                      ></form-cheque>

                      <form-tarjeta  v-if="tipo.MetodoPago === 'DEBITCARD'  ||tipo.MetodoPago === 'CREDITCARD'  ||tipo.MetodoPago === 'TRANSFER'  ||tipo.MetodoPago === 'DEPOSIT'"
                      :tipo="tipo"
                      :carritoTiposElementos="carritoTiposElementos"
                      :metodosPago="metodosPagoFiltrados"
                      :ref="`tarjetaForm_${tipo.TipoElementosId}_${tipo.MetodoPago}`"
                      :key="keyTarjetas"
                      ></form-tarjeta>
                      <!--componente tarjeta-->



                      <div
                        v-for="(item, indexItem) in carritoOrdenado.filter(
                          (el) => el.TipoElementosId === tipo.TipoElementosId
                        )"
                        :key="item.ItemCode+'-'+item.db"
                        class="mt-5 mb-4 px-0 fondo-blanco"
                      >
                        <v-row
                          class="px-2 mx-0"
                          style="border-bottom: 1px solid #ddd"
                        >
                          <v-col
                            cols="auto"
                            style="width: 5%"
                            class="px-0 ml-0 py-0 mt-3"
                          >
                            <v-btn
                              x-small
                              class="btn-panel-mas-menos"
                              @click="toggleCardItem(indexItem)"
                              style="background: #444; padding: 0px"
                                v-if="item.Aportes"
                            >
                              <v-icon
                                style="font-size: 0.8rem; margin: 0px; padding: 0px"
                              >
                                {{
                                  cardStatesItem[indexItem] ? "mdi-minus" : "mdi-plus"
                                }}
                              </v-icon>
                            </v-btn>
                          </v-col>
                          <v-col
                            cols="auto"
                            md="1"
                            class="px-2 mx-0 font-weight-bold"
                            >{{ item.ItemCode }}</v-col
                          >
                          <v-col cols="auto" style="width: 5%" class="px-0 mx-0">
                            <span
                              class="custom-badge"
                              :class="{
                                'badge-blue': item.db.substring(4, 6) === 'AC',
                                'badge-green': item.db.substring(4, 6) === 'MJ',
                                'badge-grey': item.db.substring(4, 6) === 'AN',
                              }"
                              >{{ item.db.substring(4, 6) }}</span
                            >
                          </v-col>
                          <v-col
                            cols="auto"
                            md="3"
                            class="px-0 mx-0 font-weight-bold text-left"
                            >{{ item.ForeignName | capitalizeFirst }}</v-col
                          >
                          <v-col
                            cols="auto"
                            md="2"
                            class="px-0 mx-0 font-weight-bold text-right"
                            >{{ "$ " + $formatMoney(item.priceList.Price) }}</v-col
                          >
                          <v-col
                            cols="auto"
                            md="1"
                            class="px-0 mx-0 font-weight-bold text-right"
                            >x{{ item.unidades }}</v-col
                          >
                          <v-col
                            cols="auto"
                            md="2"
                            class="px-0 mx-0 font-weight-bold info--text text-right"
                            >{{
                              "$ " +
                              $formatMoney(item.priceList.Price * item.unidades)
                            }}</v-col
                          >
                          <v-col
                            cols="auto"
                            md="1"
                            class="px-0 mx-0 font-weight-bold text-right"
                          >
                            <v-icon
                              v-if="item.ItemCode !== 'FLE' && item.ItemCode !== 'GB' && item.ItemCode !== 'GT'"
                              small
                              class="mr-2 my-0 py-0"
                              title="Eliminar"
                              @click="dialogEliminar(item.ItemCode)"
                              style="font-size: 20px; color: red"
                            >
                              mdi-delete
                            </v-icon>

                            <dialog-confirmar
                              v-model="dialogs[item.ItemCode]"
                              @input="dialog = $event"
                              :title="`¿Estás seguro de que deseas eliminar el producto <br>${capitalizeFirst(item.ForeignName)}?`"
                              info="Esta acción no se puede deshacer."
                              icon="mdi-alert-circle-outline"
                              color="#F44336"

                              @confirm="removeItem(item)"
                            />
                          </v-col>
                        </v-row>
                        <v-row
                          v-if="item.Aportes && cardStatesItem[indexItem]"
                          class="px-2 mx-0"
                          style="border-bottom: 1px solid #ddd"
                        >
                          <v-col
                            cols="auto"
                            style="width: 5%"
                            class="px-0 ml-0 py-0 mt-3"
                          >
                          </v-col>
                          <v-col
                            cols="auto"
                            md="1"
                            class="px-2 mx-0 font-weight-bold"
                          ></v-col>
                          <v-col cols="auto" style="width: 5%" class="px-0 mx-0">
                          </v-col>
                          <v-col
                            cols="auto"
                            md="3"
                            class="px-0 mx-0 font-weight-bold text-left"
                            >{{
                              item.Aportes.aporteItemName | capitalizeFirst
                            }}</v-col
                          >
                          <v-col
                            cols="auto"
                            md="2"
                            class="px-0 mx-0 font-weight-bold text-right"
                            >{{
                              "$ " + $formatMoney(item.Aportes.aporteItemPrice)
                            }}</v-col
                          >
                          <v-col
                            cols="auto"
                            md="1"
                            class="px-0 mx-0 font-weight-bold text-right"
                            >x{{ item.unidades }}</v-col
                          >
                          <v-col
                            cols="auto"
                            md="2"
                            class="px-0 mx-0 font-weight-bold info--text text-right"
                            >{{
                              "$ " +
                              $formatMoney(
                                item.Aportes.aporteItemPrice * item.unidades
                              )
                            }}</v-col
                          >
                        </v-row>

                      </div>
              </v-card-text>
            </v-card>
          </div>
          <div class="carrito__div pa-0 ma-0" style="height: 20vh">


          </div>
        </v-col>
        <v-col cols="auto" md="3" class="ma-0 pa-0">
          <v-row class="pt-0 my-0 ml-2" style="font-size: 13px; color: #444">
            <v-col cols="12" md="7" class="py-0 text-start">
              <span class="ml-0 text-h6" style="">Resumen</span></v-col
            >
          </v-row>

          <v-row v-if="$store.state.carrito.sumasPorTipo[1]" class="pt-4 my-0 ml-2" style="font-size: 13px; color: #444">
            <v-col cols="12" md="7" class="py-0 text-start"
              >Subtotal de elementos registrales:</v-col
            >

            <v-col cols="12" md="5" class="py-0 text-end pr-4 mr-0">
              ${{
                $store.state.carrito.sumasPorTipo[1]
                  ? $formatMoney($store.state.carrito.sumasPorTipo[1].subtotal)
                  : ""
              }}
            </v-col>
          </v-row>

          <v-row  v-if="$store.state.carrito.sumasPorTipo[2]" class="pt-4 my-0 ml-2" style="font-size: 13px; color: #444">
            <v-col cols="12" md="7" class="py-0 text-start"
              >Subtotal de elementos aduana:</v-col
            >

            <v-col cols="12" md="5" class="py-0 text-end pr-4 mr-0">
              ${{
                $store.state.carrito.sumasPorTipo[2]
                  ? $formatMoney($store.state.carrito.sumasPorTipo[2].subtotal)
                  : ""
              }}
            </v-col>
          </v-row>

          <v-row  v-if="$store.state.carrito.sumasPorTipo[3]" class="pt-4 my-0 ml-2" style="font-size: 13px; color: #444">
            <v-col cols="12" md="7" class="py-0 text-start"
              >Subtotal Adquirir saldo corriente:</v-col
            >

            <v-col cols="12" md="5" class="py-0 text-end pr-4 mr-0">
              ${{
                $store.state.carrito.sumasPorTipo[3]
                  ? $formatMoney($store.state.carrito.sumasPorTipo[3].subtotal)
                  : ""
              }}
            </v-col>
          </v-row>

          <v-row v-if="$store.state.carrito.gastosBancario>0" class="pt-4 my-0 ml-2" style="font-size: 13px; color: #444">
            <v-col cols="12" md="7" class="py-0 text-start"
              >Gastos Bancarios:</v-col
            >

            <v-col cols="12" md="5" class="py-0 text-end pr-4 mr-0">
              ${{
                $store.state.carrito.gastosBancario
                  ? $formatMoney(parseFloat($store.state.carrito.gastosBancario ))
                  : ""
              }}
            </v-col>
          </v-row>
           <v-row v-if="$store.state.carrito.gastosTransferencia>0" class="pt-4 my-0 ml-2" style="font-size: 13px; color: #444">
            <v-col cols="12" md="7" class="py-0 text-start"
              >Gastos Transferencia:</v-col
            >

            <v-col cols="12" md="5" class="py-0 text-end pr-4 mr-0">
              ${{
                $store.state.carrito.gastosTransferencia
                  ? $formatMoney(parseFloat($store.state.carrito.gastosTransferencia ))
                  : ""
              }}
            </v-col>
          </v-row>
          <v-row   v-if="!this.$store.state.carrito.cliente.CardCode" class="pt-4 my-0 ml-2" style="font-size: 13px; color: #444">
            <v-col  cols="12" md="7" class="py-0 text-start"
            >Envío por correo:
            </v-col
            >

            <v-col cols="12" md="5" class="py-0 text-end pr-4 mr-0">
              {{
                $store.state.carrito.gastosEnvio > 0
                  ? '$ '+$formatMoney($store.state.carrito.gastosEnvio)
                  : ""
              }}
            </v-col>
          </v-row>

          <hr  v-if="!this.$store.state.carrito.cliente.CardCode"
            style="border: none; height: 1px; background-color: #ccc"
            class="mx-1"
          />

          <v-row
            class="py-4 my-0 ml-2 py-2"
            style="font-size: 13px; color: #000; font-weight: 600"
          >
            <v-col cols="12" md="7" class="py-0 text-start"> Total</v-col>

            <v-col cols="12" md="5" class="py-0 text-end pr-4 mr-0">

              ${{
                $store.state.carrito.total
                  ? $formatMoney($store.state.carrito.total)
                  : ""
              }}
            </v-col>
          </v-row>

          <v-row class="py-1 my-0 mx-0">
            <v-col cols="12" md="12" class="mx-auto">
              <v-btn
                block
                color="btnPrimary"
                class="capitalize-first custom-btn"
                @click="dialogValidate"                
              >
                Confirmar
              </v-btn>
              <dialog-validate
                v-model="dialogs['carritoValidateMetodosPago']"
                @input="dialog = $event"
                title="Método de pago requerido"
                info="Selecciona un método de pago para cada categoría antes de continuar con la compra."
                icon="mdi-alert-circle-outline"
                color="#ffc107"
              />
              <dialog-validate
                v-model="dialogs['validateCheque']"
                 @input="dialog = $event"
                title="Error en los datos del Cheque"
                info="Verifique los datos del cheque para finalizar tu compra."
                icon="mdi-alert-circle-outline"
                color="#ffc107"
              />
              <dialog-validate
                v-model="dialogs['bancoNacionLimit']"
                @input="dialog = $event"
                title="Boleta Banco Nación no disponible"
                info="El método 'Boleta Banco Nación' no está disponible para montos superiores a $9.999.999. Por favor, elige otro método para continuar."
                icon="mdi-alert-circle-outline"
                color="#ffc107"
              />
              <dialog-validate
                v-model="dialogs['validateStock']"
                 @input="dialog = $event"
                title="Stock Insuficiente"
                info="No hay suficientes unidades disponibles. Ajusta la cantidad o intenta más tarde"
                icon="mdi-alert-circle-outline"
                color="#ffc107"
              />

              <dialog-confirmar
                v-model="dialogs['carritoFacturas']"
                @input="dialog = $event"
                title="¿Estás seguro de que desea generar las facturas?"
                info="Esta acción no se puede deshacer."
                icon="mdi-alert-circle-outline"
                color="#0078D4"

                @confirm="viewFacturas()"
              />
              <v-btn
                block
                color="danger"
                class="mt-1 capitalize-first custom-btn"
                @click="dialogVaciar"
              >
                Vaciar Carrito
              </v-btn>


              <dialog-confirmar
                v-model="dialogs['carritoVaciar']"
                @input="dialog = $event"
                title="Vaciar carrito"
                info="¿Estás seguro de que quieres vaciar todos los articulos de tu carrito? Esta acción no se puede deshacer."
                icon="mdi-cart-outline"
                color="#F44336"

                @confirm="carritoVaciar()"
              />

              <dialog-validate
                v-model="dialogs['validateTarjeta']"
                 @input="dialog = $event"
                title="Error en los datos ingresados"
                info="Verifique los datos del metodo de pago elegido para finalizar tu compra."
                icon="mdi-alert-circle-outline"
                color="#ffc107"
              />

              <dialog-form-validate
                v-model="dialogs['validateImporte']"
                @input="dialog = $event"
                title="Monto Insuficiente"

                bodyText="El monto ingresado es menor al necesario para completar el pago. Por favor, verifica la cantidad e intenta nuevamente"
                icon="mdi-currency-usd"
                color="#ffc107"
              />


            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>

    <v-snackbar
      v-model="snackbar"
      :bottom="true"
      :color="color"
      :timeout="timeout"
    >
      <div v-html="text"></div>

      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snackbar = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
    <vue-confirm-dialog></vue-confirm-dialog>

  </v-container>
</template>

<script>
import { mapState } from "vuex";
import Swal from "sweetalert2";

import DialogValidate from "@/views/dialogs/Validate.vue";
import DialogFormValidate from "@/views/dialogs/FormValidate.vue";
import DialogConfirmar from "@/views/dialogs/Confirmar.vue";
import Loading from "@/views/components/Loading.vue";
import FormCheque from "@/views/carrito/FormCheque.vue";
import FormTarjeta from "@/views/carrito/FormTarjeta.vue";

export default {
  components: {
    Loading,
    DialogValidate,
    DialogConfirmar,
    FormCheque,
    FormTarjeta,
    DialogFormValidate

  },

  data: (vm) => ({
    keyTarjetas:0,
    snackbar: false,
    text: "Registro Insertado",
    route: "aportes",
    routeFactura: "facturasAnmac",
    routeOrdenes: "ordenesAnmac",
    color: "success",
    timeout: 4000,
    isLoading: true,
    loadingMsg:"obteniendo datos...",
    carritoOrdenado: [],
    panelStates: [],
    panelStatesItem: [],
    bancoNacionLimit: false,
    dialogs: {
      carritoVaciar: false,
      carritoValidateMetodosPago: false,
      validateCheque: false,      
      carritoFacturas: false,
      validateTarjeta: false,
      validateImporte:false,
      validateStock:false,
    },
    messageStock:'',
    cardStates: [],
    cardStatesItem: [],
    metodosPagoFiltrados:[],
    metodosOrders: ['BANKNACION_EFECTIVO', 'BANKNACION_CHEQUE'],

  }),



  mounted() {
    this.loadData();
    console.log("Componente " + this.baseUrl + " creado");
  },

  computed: {
    ...mapState({
      carrito: (state) => state.carrito,
    }),
    paymentMethods() {
      return this.$store.getters.getPaymentMethods;
    },


  },

  methods: {

    paymentMethodsFilter() {



        this.metodosPagoFiltrados = this.$store.getters.getPaymentMethods.filter((method) => {


            if (method.groupCode === 'BTOB' ||  method.groupCode === 'SALDO') {
            return false;
            }
            else
            {
              if(method.groupCode =="BANKNACION")
              {
                if(this.$store.state.user.sapProperties.delegInfo.U_BANKNACION =="tYES")
                {
                  return true;
                }
                else
                {
                  return false;
                }
              }

              if(method.groupCode =="DEBITCARD")
              {
                if(this.$store.state.user.sapProperties.delegInfo.U_DEBITCARD =="tYES")
                {
                  return true;
                }
                else
                {
                  return false;
                }
              }

              if(method.groupCode =="CREDITCARD")
              {
                if(this.$store.state.user.sapProperties.delegInfo.U_CREDITCARD =="tYES")
                {
                  return true;
                }
                else
                {
                  return false;
                }
              }

              if(method.groupCode =="DEPOSIT")
              {
                if(this.$store.state.user.sapProperties.delegInfo.U_DEPOSIT =="tYES")
                {
                  return true;
                }
                else
                {
                  return false;
                }
              }

              if(method.groupCode =="TRANSFER")
              {
                if(this.$store.state.user.sapProperties.delegInfo.U_TRANSFER =="tYES")
                {
                  return true;
                }
                else
                {
                  return false;
                }
              }

            }

          // Devuelve todos los demás métodos
          return true;
        });

    },

    /*
    async fetchSaldoAFavor() {
      try {
        const cliente = this.$store.state.user.sapProperties.CardCode;
        const bases =  this.$db("ACARA")+','+this.$db("MJ");

        const saldos = await this.$store.dispatch('saldoCC/fetchItemsSaldo', {
          modo: 'consultar',
          cliente,
          bases,
        });

        if (saldos) {
          this.validarSaldoAFavor(saldos);
        } else {
          console.error('No se pudieron obtener los saldos.');
        }
      } catch (error) {
        console.error('Error al consultar los saldos:', error);
      }
    },


    validarSaldoAFavor(saldos) {
      const elementosRegistrales = this.carritoOrdenado.filter(
        (tipo) => tipo.TipoElementosId === 1
      );

      // Si no hay elementos registrales, no ejecutar el resto del método
      if (!elementosRegistrales) {
        return;
      }




      let DBACARA = this.$db("ACARA");
      let DBMJ = this.$db("MJ");

      const saldoACARA = Math.abs(parseFloat(saldos[DBACARA]?.CurrentAccountBalance || 0));
      const saldoMJ = Math.abs(parseFloat(saldos[DBMJ]?.CurrentAccountBalance || 0));

      const subtotalMJ = elementosRegistrales
        .filter((item) => item.db === this.$db("MJ"))
        .reduce((acc, item) => acc + item.priceList.Price * item.unidades, 0);

      const subtotalACARA = elementosRegistrales
        .filter((item) => item.db === this.$db("ACARA"))
        .reduce((acc, item) => acc + item.priceList.Price * item.unidades, 0);

      const gastoEnvioMJ = elementosRegistrales
        .filter((item) => item.db === this.$db("MJ") && item.ItemCode === "FLE")
        .reduce((acc, item) => acc + item.priceList.Price * item.unidades, 0);

      const esValidoMJ = subtotalMJ <= saldoMJ;
      const esValidoACARA = (subtotalACARA + gastoEnvioMJ) <= saldoACARA;

      // Actualizar el estado en base a validaciones
      this.paymentMethods.forEach((tipo) => {
        if (tipo.code == 'SALDO') {
          tipo.disabled = !(esValidoACARA && esValidoMJ);
        }
      });
    },
     */
/*
    async calcularCostoFlete() {
      // Eliminar cualquier gasto de envío existente antes de recalcular
      this.carritoOrdenado = this.carritoOrdenado.filter((item) => item.ItemCode !== "FLE");

      const articulosConFlete = this.carrito.data.filter((item) => item.U_Flete === "tYES" && item.InventoryItem === true);

      // Si no hay artículos que paguen flete, salir de la función
      if (articulosConFlete.length === 0) {
        this.$store.state.carrito.data = this.carritoOrdenado;
        this.$store.commit("carrito/calcularTotales");
        return;
      }

      const articulosPorAlmacen = articulosConFlete.reduce((acc, item) => {
        const almacen = item.DefaultWarehouse;
        if (!acc[almacen]) {
          acc[almacen] = [];
        }
        acc[almacen].push(item);
        return acc;
      }, {});

      let cantidadEnviosTotal = 0;
      const precioUnitarioEnvio = this.$store.getters.getPrecioFlete;

      // Calcular la cantidad de envíos necesarios para cada almacén
      for (const warehouseCode in articulosPorAlmacen) {
        try {
          const response = await this.$axiosApi.getById(
            "warehousesByCode",
            `${warehouseCode}/`+this.$db("ACARA")
          );

          const U_UnidFleteC = response.data?.data?.U_UnidFleteC;
          if (!U_UnidFleteC) continue;

          const cantidadArticulos = articulosPorAlmacen[warehouseCode].reduce(
            (acc, item) => acc + item.unidades,
            0
          );

          cantidadEnviosTotal += Math.ceil(cantidadArticulos / U_UnidFleteC);

        } catch (error) {
          console.error(`Error al obtener U_UnidFleteC para ${warehouseCode}:`, error);
        }
      }

      const gastoFlete = {
        TipoElementosDesc: "Elementos Registrales",
        TipoElementosId: 1,
        ItemCode: "FLE",
        ItemName: "ENVIO X CORREO",
        ForeignName: "ENVIO X CORREO",
        priceList: { Price: precioUnitarioEnvio },
        unidades: cantidadEnviosTotal,
        db: this.$db("ACARA"),
        error: ""
      };

      this.carritoOrdenado.push(gastoFlete);

      // Actualizar el estado del carrito y recalcular totales
      this.$store.state.carrito.data = this.carritoOrdenado;
      this.$store.commit("carrito/calcularTotales");
    },

    async fetchAportesData() {
      try {
        let userState =
          this.$store.state.user.sapProperties.BPAddresses[1].State;
        let userPriceList = this.$store.state.user.sapProperties.PriceListNum;
        let userPartner = this.$store.state.user.sapProperties.Properties39;
        let userAdefa = this.$store.state.user.sapProperties.Properties41;
        let items = this.carrito.data.map((item) => item.ItemCode);

        //console.log(this.$store.state.user.sapProperties);

        let formSap = {
          items: {
            userState: userState, //reemplazar con los valores reales del user
            userPriceList: userPriceList,
            userPartner: userPartner, //reemplazar con los valores reales del user
            userAdefa: userAdefa, //reemplazar con los valores reales del user
            itemsID: items,
          },
        };
        const response = await this.$axiosApi.post(this.route, formSap);
        if (response.status != 200) {
          throw new Error(`Error: ${response.status}`);
        }
        const data = await response.data.data;

        return data;
      } catch (error) {
        console.error("Error en la conexión con la API:", error);
      }
    },*/
    async loadData() {
      this.isLoading = true;
      //aca tengo q llamar al endpoint para buscar la info d los aportes
      console.log("Conectando a la API para obtener datos del usuario...");

      // Llamamos al método fetchUserData y esperamos la respuesta
      /*const itemsAportes = await this.fetchAportesData();

      let dataCarrito = this.carrito.data;

      if (itemsAportes) {
        itemsAportes.forEach((element) => {
          //console.log(element);
          const indice = dataCarrito.findIndex(
            (carrito) => carrito.ItemCode === element.U_ArtOrigen
          );
          //creo un nuevo indice en el objeto para setear los aportes
          dataCarrito[indice].Aportes = element;
        });
        this.carrito.data = dataCarrito;
      }*/

      setTimeout(() => {


        this.carritoOrdenado = this.carrito.data
          .slice()
          .sort((a, b) => a.TipoElementosId - b.TipoElementosId);

        this.carritoTiposElementos = this.obtenerTiposElementos();

        this.mergedTiposElementosConStore(),

        //recorrer tipos de elementos si tienen metodopago seteado calcular segun metodo

        this.carritoTiposElementos.forEach((e) => {
            if (e.MetodoPago) {
              this.changeMethodPayment(e);
            }
        });

        this.paymentMethodsFilter();

        this.isLoading = false;

        this.panelStates = this.carritoTiposElementos.map(() => false);

        /*if(!this.$canSap("venderElementosAnmac")) //sino es anmac
        {
          this.calcularCostoFlete();
        }*/
        this.$store.commit("carrito/calcularTotales");



        //this.fetchSaldoAFavor();
      }, 400);
    },
    obtenerTiposElementos(){
      // Primero mapeamos el carrito para obtener solo TipoElementosId y TipoElementosDesc
        let tipoElementosArray = this.carritoOrdenado.map((item) => ({
          TipoElementosId: item.TipoElementosId,
          TipoElementosDesc: item.TipoElementosDesc,
          MetodoPago: "",
          Cheques:
            {
              anmac:
              {
              banco:"",
              importe:"",
              vtoCheque:"",
              nroCheque:"",
              },


              mj:
              {
                banco:"",
                importe:"",
                vtoCheque:"",
                nroCheque:"",
              }

            },
          Tarjeta:
            {
              anmac:
              {
              banco:"",
              importe:"",
              vtoTarjeta:"",
              nroTarjeta:"",
              },


              mj:
              {
                banco:"",
                importe:"",
                vtoTarjeta:"",
                nroTarjeta:"",
              }

            }



        }));

        // Luego, eliminamos duplicados usando `filter` y `findIndex`

        return tipoElementosArray.filter( (item, index, self) => index === self.findIndex(
              (t) =>
                t.TipoElementosId === item.TipoElementosId &&
                t.TipoElementosDesc === item.TipoElementosDesc
            )
        );

    },
    mergedTiposElementosConStore(){



        const merged = this.carritoTiposElementos.map(current => {
            // Buscar si existe en el store
            const existing = this.$store.state.carrito.tipos.find(
                item => item.TipoElementosId === current.TipoElementosId
            );
            // Si existe y tiene MetodoPago, asignarlo al elemento actual
            if (existing && existing.MetodoPago) {
                return {
                    ...current,
                    MetodoPago: existing.MetodoPago,
                };
            }
            // Si no, devolver el elemento actual tal cual
            return current;
        });

        this.$store.state.carrito.tipos = merged;
        this.carritoTiposElementos = merged;


    },

    dialogEliminar(itemId) {
      this.$set(this.dialogs, itemId, true);
    },
    dialogVaciar() {
      this.dialogs.carritoVaciar = true;
    },

    // Método para obtener todos los formularios de cheque
    getChequeForms() {
      const forms = [];
      
      // Buscar todas las refs que comiencen con 'chequeForm_'
        Object.keys(this.$refs).forEach(key => {
          if (key.startsWith('chequeForm_')) {
            const formRef = this.$refs[key];
            // Si es un array (vue a veces devuelve arrays para refs en bucles)
            if (Array.isArray(formRef)) {
              forms.push(...formRef.filter(item => item));
            } else if (formRef) {
              forms.push(formRef);
            }
          }
        });
        
        return forms;
    },
      
    // Validar todos los formularios
    validateAllChequeForms() {
      const forms = this.getChequeForms();
      let allValid = true;
      
      forms.forEach(form => {
        console.log(typeof form.validateForm);
        if (form && typeof form.validateForm === 'function') {
          const isValid = form.validateForm();
          console.log('Formulario validado:', isValid);
          if (!isValid) {
            allValid = false;
          }
        }
      });
      
      return allValid;
    },

    // Método para obtener todos los formularios de tarjetas
    getTarjetaForms() {
      return this.getFormsByType(['DEBITCARD', 'CREDITCARD', 'TRANSFER', 'DEPOSIT']);
    },

    // Método genérico para obtener formularios por tipo
    getFormsByType(metodosPago) {
      const forms = [];
      
      this.carritoTiposElementos.forEach(tipo => {
        if (metodosPago.includes(tipo.MetodoPago)) {
          const refKey = `tarjetaForm_${tipo.TipoElementosId}_${tipo.MetodoPago}`;
          const formRef = this.$refs[refKey];
          
          if (formRef) {
            if (Array.isArray(formRef)) {
              forms.push(...formRef.filter(item => item && typeof item.validateForm === 'function'));
            } else if (formRef && typeof formRef.validateForm === 'function') {
              forms.push(formRef);
            }
          }
        }
      });
      
      return forms;
    },
      
    // Validar todos los formularios
    validateAllTarjetaForms() {
      const forms = this.getTarjetaForms();
      let allValid = true;
      
      forms.forEach(form => {
        console.log(typeof form.validateForm);
        if (form && typeof form.validateForm === 'function') {
          const isValid = form.validateForm();
          console.log('Formulario validado:', isValid);
          if (!isValid) {
            allValid = false;
          }
        }
      });
      
      return allValid;
    },

    dialogValidate() {
      // Bandera para verificar si todos los métodos de pago están seleccionados
      let allMethodsSelected = true;
      //let hasChequeSelected = false;
      let validacionCheque =true;
      let validacionTarjeta =true;
      let validacionImporte =true;
      // Recorre los tipos de elementos en el carrito y verifica sus métodos de pago

      this.carritoTiposElementos.forEach((tipo) => {

        if (!tipo.MetodoPago) {
          // Si algún método de pago no está seleccionado, marca la bandera y muestra el diálogo de validación
          allMethodsSelected = false;
        } else if (tipo.MetodoPago === "BANKNACION_CHEQUE") {
          // Validar todos los formularios de cheque primero
          const areChequesValid = this.validateAllChequeForms();
          console.log("Validación de cheques:", areChequesValid);
          if (!areChequesValid) {
            validacionCheque =false;                
          }
          if(this.$store.state.carrito.sumasPorTipo[tipo.TipoElementosId].subtotalDb[this.$db("ANMAC")] >0)
          {
                if(tipo.Cheques.anmac.banco =='' || tipo.Cheques.anmac.importe == '' || (tipo.Cheques.anmac.importe ==0)
                || (tipo.Cheques.anmac.vtoCheque =='') || (tipo.Cheques.anmac.nroCheque =='') )
                {
                  validacionCheque =false;
                }
          }
          if(tipo.Cheques.anmac.importe < this.$store.state.carrito.total)
          {
                validacionImporte =false;
          }
        }
        else if(tipo.MetodoPago === "DEBITCARD"  ||tipo.MetodoPago === "CREDITCARD"  ||tipo.MetodoPago === "TRANSFER"  ||tipo.MetodoPago === "DEPOSIT"){

                console.log(this.$store.state.carrito.sumasPorTipo[tipo.TipoElementosId]);
                const areTarjetasValid = this.validateAllTarjetaForms();
                console.log("Validación de tarjetas:", areTarjetasValid);
                if (!areTarjetasValid) {
                  validacionTarjeta =false;                
                }

                if(this.$store.state.carrito.sumasPorTipo[tipo.TipoElementosId].subtotalDb[this.$db("ANMAC")] >0)
                {
                  console.log(tipo.Tarjeta.anmac);
                  if(tipo.Tarjeta.anmac.banco =='' || tipo.Tarjeta.anmac.importe == '' || (tipo.Tarjeta.anmac.importe ==0)
                  || (tipo.Tarjeta.anmac.vtoTarjeta =='') || (tipo.Tarjeta.anmac.nroTarjeta =='') )
                      {
                        validacionTarjeta =false;
                      }
                }
                if(tipo.Tarjeta.anmac.importe < this.$store.state.carrito.total)
                {
                  validacionImporte =false;
                }
         }
        //validacion tarjeta
      });


      // Si no todos los métodos de pago están seleccionados, muestra el diálogo de validación
      if (!allMethodsSelected) {
        this.dialogs.carritoValidateMetodosPago = true;
      }  else if(!validacionCheque){
        this.dialogs.validateCheque = true;
      }else if(!validacionTarjeta){
        this.dialogs.validateTarjeta = true;
      }else if(!validacionImporte){
        this.dialogs.validateImporte =true
      }

      else{


        this.dialogs.carritoFacturas = true;
      }
    },

    isDelegation(userPorperties) {
      return (
        userPorperties.Properties16 === true ||
        userPorperties.Properties21 === true ||
        userPorperties.Properties16 === 'tYES' ||
        userPorperties.Properties21 === 'tYES'
      );
    },
    async isOrder(array) {
      //return array.some(item => this.metodosOrders.has(item.MetodoPago));
      return array.some(item => item.MetodoPago === 'BANKNACION_EFECTIVO' || item.MetodoPago === 'BANKNACION_CHEQUE');
    },
    async storeFactura() {
      try {
        //console.log(this.carritoTiposElementos);
        let formUserData = {};
        let url = '';
        let whsCode = this.$store.state.user.sapProperties.delegInfo.U_WhsDisp;
        let poi = this.$store.state.user.sapProperties.delegInfo.U_POI;
        let order = await (this.isOrder(this.carritoTiposElementos));


        if(order == true){
          url = this.routeOrdenes;
          /*formUserData = {
            cardCode: this.$store.state.carrito.cliente.CardCode,
            delegation: this.isDelegation(this.$store.state.carrito.cliente),
            uNamePortal: this.$store.state.carrito.cliente.CardCode,
            namePortal: this.$store.state.carrito.cliente.CardName,
          };*/
        }
        else{
          url = this.routeFactura;
          /*formUserData = {
            cardCode: this.$store.state.user.sapProperties.CardCode,
            delegation: this.isDelegation(this.$store.state.user.sapProperties),
            uNamePortal: this.$store.state.user.sapProperties.CardCode,
            namePortal: this.$store.state.user.sapProperties.CardName,
          };*/
        }
        //console.log(url);
        formUserData = {
            cardCode: this.$store.state.carrito.cliente.CardCode,
            //delegation: this.isDelegation(this.$store.state.carrito.cliente),
            delegation: this.$store.state.user.sapProperties.U_Deleg && this.$store.state.user.sapProperties.U_Deleg!='null'?this.$store.state.user.sapProperties.U_Deleg:this.$store.state.user.sapProperties.CardCode,

            uNamePortal:(this.$store.state.user.sapProperties.U_UnamePortal!='null')?this.$store.state.user.sapProperties.U_UnamePortal:this.$store.state.user.sapProperties.CardCode,
            namePortal:(this.$store.state.user.sapProperties.U_NamePortal!='null')?this.$store.state.user.sapProperties.U_NamePortal:this.$store.state.user.sapProperties.CardName,
            /*uNamePortal: this.$store.state.carrito.cliente.CardCode,
            namePortal: this.$store.state.carrito.cliente.CardName,*/
            whsVenta: whsCode, //almacen de ventas
            poi:poi //point of issue code
          };
        let form = {
          userData: formUserData,
          elementsTypes: this.carritoTiposElementos,
          items: this.carrito.data,
        };
        console.log(form);
        //verificar en el back el metodo ordenes de servicelayer para venta anmac
        const response = await this.$axiosApi.post(url, form);

        if (response.status != 200) {
          throw new Error(`Error: ${response.status}`);
        }
        const data = await response;
console.log(data);
        return data;
      } catch (error) {
        console.error("Error en la conexión con la API:", error);
        return error;

      }
    },

    async viewFacturas() {

      this.isLoading = true;
      this.loadingMsg = "Generando Facturas...";
      //console.log(this.$store.state.carrito.cliente)

      // Llamamos al método storeFactura y esperamos la respuesta
      const responseFactura = await this.storeFactura();

        //console.log(responseFactura.code);
        //console.log(responseFactura.message);



      if (responseFactura.status == 200) {
        let dataFacturas = responseFactura.data.data;
        console.log("dataFacturas");
        //console.log(dataFacturas[0].PointOfIssueCode);
        if(dataFacturas.length > 0){
          this.$router.push({
            name: "carrito_detalle_facturacion",
            params: { facturas: dataFacturas },
          });
          this.$store.commit("carrito/remove");
          this.$store.commit("carrito/removeCliente");
        }
        else{

          this.dialogs.validateStock = true;
          this.messageStock = responseFactura.data.message;
        }

      }
      else
      {
        this.isLoading = false;
        this.dialogs.carritoFacturas = false;

        let message=  responseFactura.messages ?? "";
        Swal.fire({
            icon: "error",
            title: "No se generaron los pedidos correspondientes",
            html: message,
          });

      }

    },

    carritoVaciar() {
      this.$store.commit("carrito/remove");
      this.dialogs.carritoVaciar = false;
      this.loadData();
      this.$forceUpdate();
    },

     removeItem(item) {
      //this.eliminarGastos("GT",item.TipoElementosId);

      //this.eliminarGastos("GB",item.TipoElementosId);
      //this.eliminarGastos("FLE",item.TipoElementosId);
      this.$store.commit("carrito/removeItem", item);
      this.$delete(this.dialogs, item.ItemCode);
      //this.changeMethodPayment(item.tipoElementoId);



      this.loadData();

    },
    togglePanel(index) {
      this.$set(this.panelStates, index, !this.panelStates[index]);
    },

    togglePanelItem(index) {
      this.$set(this.panelStatesItem, index, !this.panelStatesItem[index]);
    },

    toggleCard(index) {
      // Alterna la expansión de la tarjeta
      this.$set(this.cardStates, index, !this.cardStates[index]);
    },
    toggleCardItem(indexItem) {
      // Alterna la expansión del ítem dentro de la tarjeta
      this.$set(
        this.cardStatesItem,
        indexItem,
        !this.cardStatesItem[indexItem]
      );
    },

    changeMethodPayment(tipo){

        this.isLoading = true;

        setTimeout(() => {
                //saldo
                //this.eliminarGastos("GT",tipo.TipoElementosId);
                //this.eliminarGastos("GB",tipo.TipoElementosId);


                //let gasto_bancarioACARA =0;
                //let gasto_bancarioMJ =0;
                //let gasto_transferenciaACARA =0;
                //let gasto_transferenciaMJ =0;

                this.cardStates[tipo.TipoElementosId-1] = true;//despliega el card despues de seleccionar el metodo de pago

                if(tipo.TipoElementosId==1 || tipo.TipoElementosId==3  || tipo.TipoElementosId==5)
                {
                  
                  if(tipo.MetodoPago === 'DEBITCARD'  ||tipo.MetodoPago === 'CREDITCARD'  ||tipo.MetodoPago === 'TRANSFER'  ||tipo.MetodoPago === 'DEPOSIT'){
                    this.keyTarjetas = this.keyTarjetas+1;
                  }
                  

                      if((tipo.MetodoPago == 'BTOB'))
                      {

                        this.carritoOrdenado.filter( (el) => el.TipoElementosId === tipo.TipoElementosId )
                                              .forEach(item => {

                              /*if(item.db ==this.$db("ACARA"))
                              {
                                  //elem registrales o aduana
                                  if (item.InventoryItem ) {
                                      gasto_transferenciaACARA += (item.priceList.Price * item.unidades * this.$store.state.config.gasto_transferencia);

                                  }

                                  //adquirir saldo ACARA
                                  if (item.ItemCode =="PA") {
                                      gasto_transferenciaACARA += (item.priceList.Price * item.unidades * this.$store.state.config.gasto_transferencia);

                                  }
                              }
                              if(item.db ==this.$db("MJ"))
                              {
                                  //elem registrales o aduana
                                  if (item.InventoryItem   ) {
                                      gasto_transferenciaMJ += (item.priceList.Price * item.unidades * this.$store.state.config.gasto_transferencia);

                                      if(item.Aportes)
                                      {
                                        gasto_transferenciaACARA += item.Aportes.aporteItemPrice * item.unidades  * this.$store.state.config.gasto_transferencia;

                                      }
                                  }
                                  //adquirir saldo MJ
                                  if (item.ItemCode =="P2"  ) {
                                      gasto_transferenciaMJ += (item.priceList.Price * item.unidades * this.$store.state.config.gasto_transferencia);

                                  }
                              }*/


                        });
                        /*
                        let minGastoTransferencia = this.$store.state.config.gasto_transferencia_min;
                        if(gasto_transferenciaACARA < minGastoTransferencia && gasto_transferenciaACARA >0)
                        {
                          gasto_transferenciaACARA =minGastoTransferencia;
                        }

                        if(gasto_transferenciaMJ < minGastoTransferencia && gasto_transferenciaMJ >0)
                        {
                          gasto_transferenciaMJ =minGastoTransferencia;
                        }


                          if (gasto_transferenciaACARA  >0) {

                            // array minimo de gb hay que corroborar si es suficiente para
                            // la factura, sino habra q hacer un getItem GT


                              let gtACARA={
                                "TipoElementosDesc": tipo.TipoElementosDesc,
                                "TipoElementosId": tipo.TipoElementosId,
                                "ItemCode": "GT",
                                "ItemName": "Gastos Transferencia",
                                "ForeignName": "Gastos Transferencia",
                                "priceList":{"Price":gasto_transferenciaACARA},
                                "unidades":1,
                                "db":this.$db("ACARA"),
                                "error":""
                              }


                              this.carritoOrdenado.push(gtACARA);
                          }

                          if (gasto_transferenciaMJ  >0) {
                            let gtMJ={
                                "TipoElementosDesc": tipo.TipoElementosDesc,
                                "TipoElementosId": tipo.TipoElementosId,
                                "ItemCode": "GT",
                                "ItemName": "Gastos Transferencia",
                                "ForeignName": "Gastos Transferencia",
                                "priceList":{"Price":gasto_transferenciaMJ},
                                "unidades":1,
                                "db":this.$db("MJ"),
                                "error":""
                              }
                              this.carritoOrdenado.push(gtMJ);
                          }
                          */





                      }
                      else if( (tipo.MetodoPago == 'BANKNACION_CHEQUE'|| tipo.MetodoPago =='BANKNACION_EFECTIVO'))
                      {

                        if(Number(this.$store.state.carrito.sumasPorTipo[tipo.TipoElementosId].subtotal) > 9999999) {
                          this.dialogs.bancoNacionLimit = true;
                          tipo.MetodoPago = '';
                          this.isLoading = false;
                          return;
                        }

                         /* let gasto_bancarioMinimo =   this.$store.state.config.gasto_bancario_min;;

                          this.carritoOrdenado.filter( (el) => el.TipoElementosId === tipo.TipoElementosId )
                                              .forEach(item => {
                              if(item.db ==this.$db("ACARA"))
                              {
                                gasto_bancarioACARA += (item.priceList.Price * item.unidades * this.$store.state.config.gasto_bancario);
                              }
                          });

                          this.carritoOrdenado.filter( (el) => el.TipoElementosId === tipo.TipoElementosId )
                                              .forEach(item => {
                              if(item.db ==this.$db("MJ"))
                              {
                                gasto_bancarioMJ += (item.priceList.Price * item.unidades * this.$store.state.config.gasto_bancario);
                                if(item.Aportes)
                                {
                                   gasto_bancarioACARA += item.Aportes.aporteItemPrice * item.unidades  * this.$store.state.config.gasto_bancario;
                                }
                                else
                                {
                                  gasto_bancarioACARA += (item.priceList.Price * item.unidades * this.$store.state.config.gasto_bancario);

                                }
                              }
                          });



                          if(gasto_bancarioACARA < gasto_bancarioMinimo && gasto_bancarioACARA >0)
                          {
                            gasto_bancarioACARA =gasto_bancarioMinimo;
                          }
                          if(gasto_bancarioMJ < gasto_bancarioMinimo && gasto_bancarioMJ >0)
                          {
                            gasto_bancarioMJ =gasto_bancarioMinimo;
                          }

                          if (gasto_bancarioACARA  >0) {

                            // array minimo de gb hay que corroborar si es suficiente para
                            // la factura, sino habra q hacer un getItem GB

                            let gbAcara={
                                  "TipoElementosDesc": tipo.TipoElementosDesc,
                                  "TipoElementosId": tipo.TipoElementosId,
                                  "ItemCode": "GB",
                                  "ItemName": "Gastos Bancarios",
                                  "ForeignName": "Gastos Bancarios",
                                  "priceList":{"Price":gasto_bancarioACARA},
                                  "unidades":1,
                                  "db":this.$db("ACARA"),
                                  "error":""
                                }


                              this.carritoOrdenado.push(gbAcara);
                          }

                          if (gasto_bancarioMJ  >0) {
                              let gbMJ={
                                "TipoElementosDesc": tipo.TipoElementosDesc,
                                "TipoElementosId": tipo.TipoElementosId,
                                "ItemCode": "GB",
                                "ItemName": "Gastos Bancarios",
                                "ForeignName": "Gastos Bancarios",
                                "priceList":{"Price":gasto_bancarioMJ},
                                "unidades":1,
                                "db":this.$db("MJ"),
                                "error":""
                              }
                              this.carritoOrdenado.push(gbMJ);
                          }
                          */


                      }
                }
                else if (tipo.MetodoPago === 'BANKNACION_CHEQUE' || tipo.MetodoPago === 'BANKNACION_EFECTIVO') {
                    if(Number(this.$store.state.carrito.sumasPorTipo[tipo.TipoElementosId].subtotal) > 9999999) {
                      this.dialogs.bancoNacionLimit = true;
                      tipo.MetodoPago = '';
                      this.isLoading = false;
                      return;
                    }
                    }

                else if (tipo.MetodoPago === 'BANKNACION_CHEQUE' || tipo.MetodoPago === 'BANKNACION_EFECTIVO') {
                    if(Number(this.$store.state.carrito.sumasPorTipo[tipo.TipoElementosId].subtotal) > 9999999) {
                      this.dialogs.bancoNacionLimit = true;
                      tipo.MetodoPago = '';
                      this.isLoading = false;
                      return;
                    }
                    }


                  this.$store.state.carrito.tipos = this.carritoTiposElementos;

                  this.$store.state.carrito.data =this.carritoOrdenado;
                  this.$store.commit("carrito/calcularTotales");
                  this.$forceUpdate();

                  this.isLoading = false;
              },100);


    },

   /* eliminarGastos(tipoGasto,tipoElementoId){
      let existingItemIndex = this.carritoOrdenado.findIndex(el => el.ItemCode === tipoGasto && el.db ===this.$db("ACARA") && el.TipoElementosId ===tipoElementoId);

      if (existingItemIndex !== -1) {
           this.carritoOrdenado.splice(existingItemIndex, 1);
      }
        let existingItemIndexMJ = this.carritoOrdenado.findIndex(el => el.ItemCode === tipoGasto && el.db ===this.$db("MJ") && el.TipoElementosId ===tipoElementoId);

      if (existingItemIndexMJ !== -1) {

          this.carritoOrdenado.splice(existingItemIndexMJ, 1);
      }

    },
    */

      capitalizeFirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
    verProductos(){
          this.$router.push({ name: 'elementos_anmac_venta' })
    }



  },
  watch: {},
};
</script>

<style>
.custom-btn {
  text-transform: none;
  font-family: inherit;
}

.capitalize-first::first-letter {
  text-transform: capitalize;
}

.small-select .v-input__control {
  min-height: 18px !important; /* Altura total del select */
}

.small-select .v-label {
  font-size: 14px !important; /* Tamaño de la fuente del label */

  line-height: 1;
}

.fondo-blanco {
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 10px;
}

.v-list-item--disabled {
  color: gray !important;
  cursor: not-allowed !important;
  opacity: 0.6 !important;
}
</style>

